import React from "react";

export default function Infos({ isSubmitting, onlineError }) {
  
  return (
    <>
      {onlineError && (
        <span className="required">
          Napaka na strežniku. Prosimo poskusite kasneje. <br />
        </span>
      )}

      {isSubmitting && (
        <div>
          Pošiljam podatke...
        </div>
      )}
    </>
  );
}
